<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        Trip handling request statement
      </h3>

      <d-row>
        <div class="form-group w-100">
          <d-textarea
            v-model="data.text"
            :value.prop="data.text"
            rows="6"></d-textarea>
        </div>
      </d-row>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="submitForm"
            theme="success"
            class="mr-5">
            Generate
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'TripHandlingRequestPopup',
  data () {
    return {
      loading: false,
      isVisible: false,
      data: {
        id: false,
        text: ''
      }
    };
  },
  mounted () {
    this.$bus.$on('show-trip-handling-request-popup', this.show);
  },
  methods: {
    show (requestData = false) {
      this.data = {
        id: requestData.id,
        type: requestData.type,
        text: requestData.text,
      };

      setTimeout(() => {
        this.isVisible = true;
      }, 100);
    },
    submitForm () {
      this.loading = true;

      this.$http.post('/trips/flights/get-handling-request/' + parseInt(this.data.id, 10), {
        trip_handling_request_statement: this.data.text,
        type: this.data.type
      }, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = response.request.getResponseHeader('content-disposition').split('filename=')[1].split(';')[0];
        link.setAttribute('download', filename.replace(/"/gmi, ''));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.loading = false;
        this.isVisible = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'An error occurred',
          html: 'Please try again',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-trip-handling-request-popup', this.show);
  }
}
</script>
